// Single source for how a resolved campaign-audio track renders: the cover
// tile, the song name, and its fallback copy. Shared by CampaignEditAudioField,
// CampaignDetailsCards, and editRequestFormat's review-diff summary so the
// placeholder wording and precedence live in one place.

export const OFFICIAL_AUDIO_SONG_FALLBACK = 'Instagram audio';
export const OFFICIAL_AUDIO_ARTIST_FALLBACK = 'Campaign audio';

export interface OfficialAudioTrackLike {
  song_name?: string;
  artist_name?: string;
  cover_url?: string;
}

export interface OfficialAudioTrackDisplay {
  cover?: string;
  song: string;
  artist: string;
}

/** Cover/song/artist for one track, with the shared fallback copy applied. */
export function officialAudioTrackDisplay(track?: OfficialAudioTrackLike | null): OfficialAudioTrackDisplay {
  return {
    cover: track?.cover_url?.trim() || undefined,
    song: track?.song_name?.trim() || OFFICIAL_AUDIO_SONG_FALLBACK,
    artist: track?.artist_name?.trim() || OFFICIAL_AUDIO_ARTIST_FALLBACK,
  };
}
